export default __webpack_public_path__ + "asset/sri-lanka.4f71eaa6d0d43b56b36db037c200b045.svg";